import { feedPage, entryShort } from "../../../app/Feed/FeedStyles";
import skeletonStyles from "./SkeletonStyles";
import ReactPlaceholder from "react-placeholder";
import "react-placeholder/lib/reactPlaceholder.css";
import { colors } from "../../styles/Colors";
/** @jsx jsx */
import { jsx } from "@emotion/core";

const PostPlaceholder = ({ children, isLoaded }) => {
    return isLoaded ? (
        children
    ) : (
        <div css={[feedPage.infiniteScroll, skeletonStyles.postContainer]}>
            <div css={feedPage.inner}>
                <div css={entryShort.body}>
                    <div css={[skeletonStyles.postPlaceholder]}>
                        <ReactPlaceholder
                            showLoadingAnimation={true}
                            type="text"
                            ready={false}
                            rows={5}
                            color={colors.greyDark10}
                        >
                            <div />
                        </ReactPlaceholder>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PostPlaceholder;
